module.exports = __webpack_public_path__ + "images/participants_background.webp";